import "./utils/importAssets.js"
import "./utils/signature.js"
import barba from "@barba/core"
import { EventEmitter, once } from "events"
import * as d3 from "d3"

import NotificationSystemController from "./components/NotificationSystemController.js"

// In charge of stuff like window resizing and updates values accordingly
import Viewport from "./utils/Viewport.js"

// A collection of global variables
import global from "./utils/global.js"

// Transitions between pages
import DefaultTransition from "./transitions/Default.js"

// Ticker (heartbeat) of application
import Ticker from "./utils/Ticker.js"

// To allow communication between classes. This speaker shouts and informs other of when things happen in the app
import Speaker from "./utils/Speaker.js"

// Pages
import HomePage from "./pages/HomePage.js"
import GlobalPage from "./pages/GlobalPage.js"
import ContactPage from "./pages/ContactPage.js"
import TourPage from "./pages/TourPage.js"
import BookingPage from "./pages/BookingPage.js"

Object.defineProperty( String.prototype, "capitalize", {
	value: function () {

		return this.charAt( 0 ).toUpperCase() + this.slice( 1 )

	},
	enumerable: false,
} )
class Application {

	static instance

	constructor() {

		if ( Application.instance ) return Application.instance
		Application.instance = this

		this.initNamespace = document.querySelector(
			'[data-barba="container"]'
		).dataset.template
		this.setCurrentNamespace( this.initNamespace )
		this.firstInit = true
		this.initialized = false
		this.noficationSystem = new NotificationSystemController(document.querySelector(".dashboard_notification_container"))

		this.init = this.init.bind( this )
		this.speaker = new Speaker()
		this.ticker = new Ticker()
		this.viewport = new Viewport()
		this.beforeEnter = this.beforeEnter.bind( this )
		this.beforeLeave = this.beforeLeave.bind( this )
		this.afterEnter = this.afterEnter.bind( this )
		this.afterLeave = this.afterLeave.bind( this )

		this.pages = {
			global: new GlobalPage(this),
			index: new HomePage(this),
			contact: new ContactPage(this),
			tour: new TourPage(this),
			booking: new BookingPage(this)
		}

		this.transitions = {
			default: new DefaultTransition()
		}


	}

	setCurrentNamespace( namespace ) {

		global.currentNamespace = namespace

	}

	switchPage( url ) {

		barba.go( url )

	}

	beforeLeave() {

		this.pages.global.beforeLeave()

	}

	afterLeave() {

		this.pages.global.afterLeave()

	}

	afterEnter( data ) {

		const { next, current } = data
		this.setCurrentNamespace( next.namespace )
		this.pages.global.afterEnter( { next, current } )

		if ( this.firstInit ) return ( this.firstInit = false )
		const hash = data.next.url.query.section

		if (!hash) return;

		const target = document.querySelector(`#${hash}`);
		console.log(target)
		if (target) {
			target.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}	

	}

	beforeEnter() {

		this.pages.global.beforeEnter()

	}

	init() {

		document.addEventListener('click', (e) => {
			const link = e.target.closest('a');

			if (!link) return;

			const url = new URL(link.href);
			const currentUrl = new URL(window.location.href);

			// Same page + has a hash
			if (
				url.pathname === currentUrl.pathname &&
				url.hash
			) {
				e.preventDefault();

				const target = document.querySelector(url.hash);

				if (target) {
					target.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
				}

				// Update URL without triggering Barba
				history.pushState(null, '', url.hash);
			}
		});
		barba.init( {
			cacheIgnore: true,
			transitions: [
				{ once: this.pages.global.beforeEnter },
				...global.transitions,
			],
			views: global.views,
			preventRunning: true,
			prevent: ({ el }) => {

				const linkUrl = new URL(el.href);
				const currentUrl = new URL(window.location.href);

				return linkUrl.pathname === currentUrl.pathname;
			
			}
		} )
		this.noficationSystem.init()
		barba.hooks.afterLeave( this.afterLeave )
		barba.hooks.afterEnter( this.afterEnter )
		barba.hooks.beforeEnter( this.beforeEnter )
		barba.hooks.beforeLeave( this.beforeLeave )

		this.speaker.addListener( "login", ( { url } ) => {

			console.log( "PICK UP LOGIN EVENT" )
			this.switchPage( url )

		} )

		window.addEventListener( "logout", () => {

			console.log( "PICK UP LOGOUT EVENT" )
			this.switchPage( "/" )

		} )

		this.initialized = true

	}

}

const app = new Application()
app.init()

